import { AppProps } from '../../../App';
import { PageTitle } from '../../../components/PageTitle';
import { FormRegistMember } from './components/FormRegistMember';

const CU00302Page = (props: AppProps) => {
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
            className="CU-003-02-container"
        >
            <PageTitle title="本人確認（eKYC外部サービス）情報入力" />

            <section
                style={{
                    height: '100%',
                    width: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                }}
            >
                <FormRegistMember {...props} />
            </section>
        </div>
    );
};
export default CU00302Page;
